import type { Frame } from '../store/types';

export interface SnapResult {
  x: number;
  y: number;
  guides: { vertical: number[]; horizontal: number[] };
}

export interface Candidates { vertical: number[]; horizontal: number[] }

export function candidates(frames: Frame[]): Candidates {
  const vertical: number[] = [];
  const horizontal: number[] = [];
  for (const f of frames) {
    const h = f.h ?? 200;
    vertical.push(f.x, f.x + f.w / 2, f.x + f.w);
    horizontal.push(f.y, f.y + h / 2, f.y + h);
  }
  return { vertical, horizontal };
}

export function snap(moving: Frame, others: Frame[], threshold: number): SnapResult {
  const c = candidates(others);
  const h = moving.h ?? 200;
  const mvEdges = [moving.x, moving.x + moving.w / 2, moving.x + moving.w];
  const mhEdges = [moving.y, moving.y + h / 2, moving.y + h];

  const matchedV: number[] = [];
  const matchedH: number[] = [];
  let dx = 0; let bestVDelta = Infinity;
  let dy = 0; let bestHDelta = Infinity;

  for (let i = 0; i < mvEdges.length; i++) {
    for (const cv of c.vertical) {
      const d = cv - mvEdges[i];
      if (Math.abs(d) <= threshold && Math.abs(d) < Math.abs(bestVDelta)) {
        bestVDelta = d; dx = d; matchedV.length = 0; matchedV.push(cv);
      } else if (d === bestVDelta) {
        matchedV.push(cv);
      }
    }
  }
  for (let i = 0; i < mhEdges.length; i++) {
    for (const ch of c.horizontal) {
      const d = ch - mhEdges[i];
      if (Math.abs(d) <= threshold && Math.abs(d) < Math.abs(bestHDelta)) {
        bestHDelta = d; dy = d; matchedH.length = 0; matchedH.push(ch);
      } else if (d === bestHDelta) {
        matchedH.push(ch);
      }
    }
  }

  return {
    x: moving.x + (Number.isFinite(bestVDelta) ? dx : 0),
    y: moving.y + (Number.isFinite(bestHDelta) ? dy : 0),
    guides: { vertical: matchedV, horizontal: matchedH },
  };
}
